var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/gp.96be49b2.png","uri@2x": __webpack_public_path__ + "static/media/gp.c12ff496.png","uri@3x": __webpack_public_path__ + "static/media/gp.eef33109.png",
    width: 50,
    height: 50
});